import { render, staticRenderFns } from "./LocationLabReportDialog.vue?vue&type=template&id=9c2c5fe6&scoped=true&"
import script from "./LocationLabReportDialog.vue?vue&type=script&lang=js&"
export * from "./LocationLabReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./LocationLabReportDialog.vue?vue&type=style&index=0&id=9c2c5fe6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2c5fe6",
  null
  
)

export default component.exports